export const SAVE_DEMO_ACTION = 'saveStartingDemoDetails';

export const SUCCESS_STATUS = 200;

export const SUBMIT_STATUS = {
  saving: 'saving',
  saved: 'saved',
};

/**
 * Event intake is run from a tablet at the trailer. The defaults below cover
 * the current event, and a rep can override any of them in the URL,
 * e.g. /demo-intake?company=2&promo=430996&rep=Randy&event=IMC26
 */
export const QUERY_PARAM = {
  COMPANY_ID: 'company',
  PROMOTION_ID: 'promo',
  REP: 'rep',
  EVENT: 'event',
  VARIANT: 'variant',
};

/** Matches the Unbounce webhook's GymMaster.DEFAULT_COMPANY_ID. */
export const DEFAULT_COMPANY_ID = 2;

/** The event this tablet is currently running. */
export const DEFAULT_EVENT = 'nutrishopsept2026';

/** Placeholder until a named rep is passed in the URL. */
export const DEFAULT_REP = 'N/A';

/** Recorded on the demo record so Booth Minder can tell leads apart by source. */
export const DEFAULT_PAGE_NAME = 'BBVR Social - Demo Intake';

/** Mirrors the Unbounce webhook's GymMaster.DEFAULT_NOTES_PREFIX. */
export const NOTES_PREFIX = 'Created From: ';

export const MAX_NAME_LENGTH = 100;
export const MAX_EMAIL_LENGTH = 254;
export const MAX_MOBILE_LENGTH = 20;
export const MAX_ZIP_LENGTH = 12;
export const MAX_REP_LENGTH = 100;
export const MAX_NOTES_LENGTH = 500;

export const DEMO_ACCENT = '#ff6b00';
export const DEMO_SUCCESS = '#7ED321';

/** Native BBVR dark form chrome (matches FormInput). */
export const DEMO_FIELD_SHELL = '#191B1C';
export const DEMO_FIELD_TEXT = '#F1F1F1';
export const DEMO_FIELD_PLACEHOLDER = 'rgba(241, 241, 241, 0.45)';
export const DEMO_FIELD_LABEL = '#F1F1F1';

export const PAGE_TITLE = 'DEMO CHECK-IN';

export const INTRO_TEXT =
  'Quick check-in before you step into the arena. Takes about thirty seconds, and it is how we send your results over after the demo.';

export const SMS_CONSENT_LABEL =
  'Text me my demo results and follow-up. Message and data rates may apply; reply STOP to opt out.';

export const ERROR_MESSAGE = {
  FIRST_NAME: 'Enter your first name.',
  LAST_NAME: 'Enter your last name.',
  EMAIL: 'Enter a valid email address.',
  MOBILE: 'Enter a valid mobile number.',
  SUBMIT: 'Check-in failed! Please try again.',
};
